import React, {ReactNode} from 'react'
import {Layout} from 'layouts'
import {Trans, useTranslation} from 'react-i18next'
// import {graphql} from 'gatsby'
// import Img  from "gatsby-image"
import {StaticImage} from 'gatsby-plugin-image'

const H3 = ({
  children,
  className = '',
}: {
  children: ReactNode
  className: string
}) => (
  <h3
    className={`md:rounded-xl rounded-lg md:px-6 px-3 md:py-2 py-1 md:m-3 m-1 ${className}`}
  >
    {children}
  </h3>
)

function Page() {
  const {t} = useTranslation()
  return (
    <Layout
      title={t('Our Team')}
      description={t(
        'Saying EVET (YES) to new challenges and a result-oriented attitude define the spirit of this company.'
      )}
      className="bg-[url(assets/images/bg-team.svg)]
      md:bg-contain bg-[length:1000px_800px]
      md:bg-top bg-[left_-8rem_top_1rem]
       bg-no-repeat"
    >
      <section className="flex flex-col items-center text-center text-gray-900">
        <h1 className="font-head font-extrabold md:text-5xl text-2xl my-10">
          <Trans>{t('EVET<br/> MINDED PEOPLE')}</Trans>
        </h1>
        <p className="md:text-3xl text-lg px-4 md:my-10 max-w-4xl">
          <Trans>
            Saying EVET (YES) to new challenges and a
            result-oriented attitude define the spirit of this
            company.
          </Trans>
        </p>
        <p
          className="font-semibold tracking-wide uppercase max-w-5xl md:mt-20
        mt-10 md:text-base text-xs md:mb-0 mb-8"
        >
          <Trans>{t("EVET's Characteristics")}</Trans>
        </p>

        <div
          className="md:text-3xl text-sm text-gray-800 max-w-8xl md:my-10
        flex flex-wrap items-center justify-center px-1"
        >
          <H3 className="bg-red-50">#challengeme</H3>
          <H3 className="bg-orange-100">#letsbuildtogether</H3>
          <H3 className="bg-emerald-100">#whatisnext</H3>
          <H3 className="bg-blue-200">#countmein</H3>
          <H3 className="bg-cyan-50">#ilikethat</H3>
          <H3 className="bg-red-50">#notimetowaste</H3>
          <H3 className="bg-lime-50">#passionate</H3>
          <H3 className="bg-cyan-50">#JourneyIsWhatMatters</H3>
        </div>

        <div
          className="pt-36 pb-10 w-full
         flex flex-col items-center justify-center md:rounded-3xl
         my-12
         bg-violet-50"
        >
          <StaticImage
            src="../../assets/images/illustrations-left-hand.png"
            alt="left hand"
            placeholder="none"
            className="absolute 2xl:left-0 xl:-left-16 lg:-left-44 md:-left-44 hidden lg:block"
          />
          <StaticImage
            src="../../assets/images/illustrations-right-hand.png"
            placeholder="none"
            alt="right hand"
            className="absolute 2xl:right-0 xl:-right-24 lg:-right-44 md:-right-44 -mt-40 hidden lg:block"
          />

          <p className="md:text-3xl text-lg px-5 max-w-7xl -mt-40 mb-10 relative">
            <Trans>
              {t(
                'Wanna do some great stuff with Extraordinary People?<br/>If your answer is yes, then you’re in the right place.'
              )}
            </Trans>
          </p>

          <div className="md:px-20 md:py-8 md:my-2 relative md:w-auto w-full px-4">
            <a
              href="https://www.linkedin.com/company/evet-com/jobs/"
              target="_blank"
              rel="nofollow"
              className="block mx-auto md:w-80 md:py-5 py-2 relative rounded-lg bg-violet-800 shadow
            text-base font-semibold text-center uppercase text-white"
            >
              {t('Come and join us')}
            </a>
            <svg
              width="59"
              height="68"
              viewBox="0 0 59 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              className="absolute right-0 top-0 md:block hidden"
            >
              <path
                d="M52.6772 1.33877C52.3864 0.869233 51.7701 0.724328 51.3006 1.01511C50.831 1.3059 50.6861 1.92226 50.9769 2.39179L52.6772 1.33877ZM0.646955 57.7947C0.168664 58.0709 0.00478941 58.6825 0.280929 59.1608L4.78093 66.955C5.05707 67.4333 5.66866 67.5972 6.14696 67.321C6.62525 67.0449 6.78912 66.4333 6.51298 65.955L2.51298 59.0268L9.44118 55.0268C9.91948 54.7506 10.0834 54.139 9.80721 53.6608C9.53107 53.1825 8.91948 53.0186 8.44119 53.2947L0.646955 57.7947ZM51.9919 4.14242C52.2549 4.62804 52.8618 4.80847 53.3475 4.54543C53.8331 4.28238 54.0135 3.67547 53.7505 3.18985L51.9919 4.14242ZM55.5654 7.05475C55.3595 6.54228 54.7772 6.29375 54.2647 6.49965C53.7522 6.70554 53.5037 7.28789 53.7096 7.80036L55.5654 7.05475ZM55.0048 11.6326C55.1523 12.1649 55.7033 12.4768 56.2355 12.3293C56.7678 12.1818 57.0797 11.6308 56.9322 11.0986L55.0048 11.6326ZM57.845 15.2649C57.7562 14.7198 57.2423 14.3499 56.6972 14.4387C56.1521 14.5275 55.7822 15.0414 55.871 15.5865L57.845 15.2649ZM56.3086 19.6137C56.3392 20.1651 56.811 20.5874 57.3624 20.5568C57.9138 20.5263 58.3361 20.0545 58.3055 19.503L56.3086 19.6137ZM58.3189 23.7643C58.3459 23.2126 57.9205 22.7436 57.3689 22.7167C56.8173 22.6897 56.3483 23.1151 56.3213 23.6667L58.3189 23.7643ZM55.9151 27.7003C55.8316 28.2462 56.2065 28.7565 56.7524 28.84C57.2983 28.9235 57.8086 28.5486 57.8921 28.0027L55.9151 27.7003ZM57.0325 32.1753C57.1716 31.6408 56.851 31.0948 56.3166 30.9557C55.7821 30.8166 55.236 31.1371 55.0969 31.6716L57.0325 32.1753ZM53.875 35.5362C53.6814 36.0534 53.9438 36.6296 54.4611 36.8232C54.9784 37.0168 55.5546 36.7544 55.7481 36.2371L53.875 35.5362ZM54.0474 40.1456C54.2941 39.6514 54.0936 39.0509 53.5995 38.8042C53.1053 38.5575 52.5048 38.7581 52.2581 39.2522L54.0474 40.1456ZM50.259 42.7733C49.9609 43.2382 50.0962 43.8567 50.5612 44.1548C51.0261 44.4529 51.6447 44.3176 51.9427 43.8526L50.259 42.7733ZM49.4481 47.3138C49.7951 46.8841 49.728 46.2545 49.2984 45.9075C48.8687 45.5605 48.2391 45.6276 47.8921 46.0573L49.4481 47.3138ZM45.1807 49.0581C44.7881 49.4466 44.7849 50.0798 45.1734 50.4723C45.5619 50.8648 46.1951 50.868 46.5876 50.4795L45.1807 49.0581ZM43.3905 53.307C43.8242 52.965 43.8984 52.3362 43.5564 51.9025C43.2143 51.4689 42.5855 51.3947 42.1519 51.7367L43.3905 53.307ZM38.8384 54.0605C38.3692 54.3517 38.2249 54.9682 38.5161 55.4375C38.8074 55.9067 39.4239 56.051 39.8931 55.7598L38.8384 54.0605ZM36.1541 57.8027C36.6526 57.5649 36.864 56.9681 36.6262 56.4696C36.3885 55.9711 35.7916 55.7597 35.2931 55.9975L36.1541 57.8027ZM31.5485 57.5416C31.0274 57.7247 30.7535 58.2956 30.9365 58.8166C31.1196 59.3377 31.6905 59.6116 32.2115 59.4285L31.5485 57.5416ZM28.1177 60.6338C28.6547 60.5048 28.9855 59.9649 28.8566 59.4279C28.7276 58.8909 28.1878 58.5601 27.6508 58.689L28.1177 60.6338ZM23.6705 59.4434C23.1237 59.5206 22.7429 60.0264 22.82 60.5733C22.8971 61.1202 23.403 61.501 23.9498 61.4238L23.6705 59.4434ZM19.729 61.8269C20.2806 61.7985 20.7047 61.3283 20.6763 60.7768C20.6479 60.2252 20.1777 59.8011 19.6262 59.8295L19.729 61.8269ZM15.5532 59.8706C15.0011 59.8541 14.5402 60.2881 14.5236 60.8402C14.507 61.3922 14.9411 61.8532 15.4932 61.8697L15.5532 59.8706ZM11.2725 61.5834C11.8218 61.6409 12.3137 61.2422 12.3712 60.6929C12.4287 60.1437 12.0301 59.6518 11.4808 59.5942L11.2725 61.5834ZM7.43152 59.0293C6.88737 58.9348 6.36969 59.2994 6.27527 59.8436C6.18084 60.3877 6.54541 60.9054 7.08956 60.9998L7.43152 59.0293ZM2.95936 60.1501C3.49672 60.2776 4.03571 59.9454 4.16324 59.408C4.29076 58.8706 3.95852 58.3316 3.42116 58.2041L2.95936 60.1501ZM50.9769 2.39179C51.3332 2.96713 51.6715 3.55094 51.9919 4.14242L53.7505 3.18985C53.4118 2.56455 53.0541 1.94723 52.6772 1.33877L50.9769 2.39179ZM53.7096 7.80036C54.2137 9.05507 54.6452 10.3347 55.0048 11.6326L56.9322 11.0986C56.553 9.73001 56.0977 8.37966 55.5654 7.05475L53.7096 7.80036ZM55.871 15.5865C56.0882 16.9198 56.2338 18.2645 56.3086 19.6137L58.3055 19.503C58.2269 18.0839 58.0737 16.6688 57.845 15.2649L55.871 15.5865ZM56.3213 23.6667C56.2554 25.0161 56.1197 26.363 55.9151 27.7003L57.8921 28.0027C58.1071 26.5977 58.2497 25.1825 58.3189 23.7643L56.3213 23.6667ZM55.0969 31.6716C54.7568 32.9786 54.3492 34.2691 53.875 35.5362L55.7481 36.2371C56.2466 34.905 56.6751 33.5487 57.0325 32.1753L55.0969 31.6716ZM52.2581 39.2522C51.6561 40.458 50.9894 41.6339 50.259 42.7733L51.9427 43.8526C52.7121 42.6524 53.414 41.4144 54.0474 40.1456L52.2581 39.2522ZM47.8921 46.0573C47.0489 47.1014 46.1448 48.1038 45.1807 49.0581L46.5876 50.4795C47.6051 49.4724 48.5589 48.4149 49.4481 47.3138L47.8921 46.0573ZM42.1519 51.7367C41.1031 52.5641 39.9983 53.3406 38.8384 54.0605L39.8931 55.7598C41.1172 55.0001 42.2833 54.1804 43.3905 53.307L42.1519 51.7367ZM35.2931 55.9975C34.094 56.5694 32.8456 57.0858 31.5485 57.5416L32.2115 59.4285C33.5758 58.9491 34.8903 58.4055 36.1541 57.8027L35.2931 55.9975ZM27.6508 58.689C26.3655 58.9977 25.0386 59.2505 23.6705 59.4434L23.9498 61.4238C25.3801 61.2221 26.7696 60.9575 28.1177 60.6338L27.6508 58.689ZM19.6262 59.8295C18.3028 59.8977 16.945 59.9124 15.5532 59.8706L15.4932 61.8697C16.9381 61.9131 18.3503 61.8979 19.729 61.8269L19.6262 59.8295ZM11.4808 59.5942C10.1588 59.4558 8.80896 59.2683 7.43152 59.0293L7.08956 60.9998C8.51026 61.2464 9.90469 61.4402 11.2725 61.5834L11.4808 59.5942ZM3.42116 58.2041C2.75528 58.0461 2.08348 57.8764 1.40577 57.6948L0.888136 59.6267C1.58415 59.8132 2.27457 59.9876 2.95936 60.1501L3.42116 58.2041Z"
                fill="#1F2937"
              />
            </svg>
          </div>
          <p
            className="max-w-lg mx:text-base
           text-xs md:mt-0 mt-10 px-5
           font-semibold text-center uppercase text-violet-800 relative"
          >
            {t(
              'and do the Most Important Work of your Career together with Extraordinary People.'
            )}
          </p>
        </div>

        <div className="xl:my-32" />
      </section>
    </Layout>
  )
}

export default Page
